import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../../../src/auth/useAuth';
import AuthSettingsItem from '../authSettings/AuthSettingsItem';

const SettingsProfile = () => {
  const navigate = useNavigate();
  const { user } = useAuth();

  if (!user) return <></>;
  return (
    <div className='flex w-full flex-col items-center justify-start gap-8 rounded-2xl bg-white p-8 shadow-md'>
      <h3 className='text-blue-primary mb-3 w-full text-2xl font-bold'>Authentification</h3>
      <AuthSettingsItem
        title='Adresse e-mail'
        description='Permet de recevoir des informations et instructions en cas de problème ou modification de votre compte.'
        fieldType='UPDATED'
        actionDate={user?.emailUpdatedAt}
        borderBottom
        actionOnClick={() => navigate(`/dashboard/settings/profile/email`)}
      />
      <AuthSettingsItem
        title='Identifiant'
        description='Couplé à votre mot de passe, vous permet de vous connecter à votre compte.'
        fieldType='UPDATED'
        actionDate={user?.nickNameUpdatedAt}
        borderBottom
        actionOnClick={() => navigate(`/dashboard/settings/profile/nickName`)}
      />
      <AuthSettingsItem
        title='Mot de passe'
        description='Permet de confirmer votre identité à la connexion.'
        fieldType='UPDATED'
        actionDate={user?.passwordUpdatedAt}
        actionOnClick={() => navigate(`/dashboard/settings/profile/password`)}
      />
    </div>
  );
};

export default SettingsProfile;
